import PageHero from '../components/PageHero';
import SectionIntro from '../components/SectionIntro';
import InfoCard from '../components/InfoCard';
import Button from '../components/Button';
import { homeImages, programHighlights, servicesPageSections, whoWeServe } from '../data/siteData';

export default function ServicesPage() {
  return (
    <>
      <PageHero
        eyebrow="Programs"
        title="Comprehensive programs that build knowledge, skills, and real-world experience"
        description="BrainTorch™ Bio prepares the next generation of clinical research professionals through STEM education, clinical research training, and career readiness pathways."
        image={homeImages.programs}
        compact
      />

      <section className="section shell">
        <SectionIntro
          eyebrow="Our Program Areas"
          title="Training pathways built for science, research, and career readiness"
          text="Programs are organized around STEM education pathways, clinical research training, and career readiness support."
          align="center"
        />
        <div className="card-grid card-grid--three top-gap-lg">
          {servicesPageSections.map((item, index) => (
            <InfoCard
              key={item.heading}
              icon={item.icon}
              title={item.heading}
              text={item.text}
              bullets={item.checklist}
              accent={index === 2 ? 'orange' : undefined}
            />
          ))}
        </div>
      </section>

      <section className="section section--contrast">
        <div className="shell">
          <SectionIntro eyebrow="Program Highlights" title="Designed for practical learning and career movement" align="center" />
          <div className="mini-card-grid mini-card-grid--five top-gap-lg">
            {programHighlights.map((item) => {
              const Icon = item.icon;
              return (
                <article key={item.title} className="mini-card">
                  <Icon size={30} />
                  <h3>{item.title}</h3>
                  <p>{item.text}</p>
                </article>
              );
            })}
          </div>
        </div>
      </section>

      <section className="section shell section--tight-top">
        <SectionIntro eyebrow="Who We Serve" title="Programs for learners at every stage" align="center" />
        <div className="audience-row top-gap-md">
          {whoWeServe.map((item) => (
            <span key={item}>{item}</span>
          ))}
        </div>
      </section>

      <section className="section shell section--tight-top">
        <div className="cta-band">
          <div>
            <h2>Ready to start your journey?</h2>
            <p>Explore our programs and take the first step toward a rewarding career in clinical research.</p>
          </div>
          <Button to="/contact#contact-form" variant="teal">Join Interest List</Button>
        </div>
      </section>
    </>
  );
}
